<script setup lang="ts">
    import { CaseStatus } from '@/api/caseSearch';
    import { computed } from 'vue';

    export interface Props {
        caseStatus: CaseStatus;
    }

    const props = defineProps<Props>();

    const iconMap = {
        [CaseStatus.Created]: 'f:case-new',
        [CaseStatus.GeneratingDicoms]: 'f:case-processing',
        [CaseStatus.ImageSegmentation]: 'f:case-processing',
        [CaseStatus.SurgicalTemplating]: 'f:case-processing',
        [CaseStatus.GeneratingPlan]: 'f:case-processing',
        [CaseStatus.Completed]: 'f:case-completed',
        [CaseStatus.Warning]: 'f:case-completed',
        [CaseStatus.Error]: 'f:case-error',
    };

    const statusMap = {
        [CaseStatus.Created]: 'Awaiting imaging',
        [CaseStatus.GeneratingDicoms]: 'Processing',
        [CaseStatus.ImageSegmentation]: 'Processing',
        [CaseStatus.SurgicalTemplating]: 'Processing',
        [CaseStatus.GeneratingPlan]: 'Processing',
        [CaseStatus.Completed]: 'Plan available',
        [CaseStatus.Warning]: 'Manual planning required',
        [CaseStatus.Error]: 'Technical issue',
    };

    const statusKey = computed(() => {
        if (props.caseStatus === CaseStatus.Error) {
            return CaseStatus.Error;
        }

        return props.caseStatus;
    });

    const icon = computed(() => iconMap[statusKey.value]);

    const status = computed(() => statusMap[statusKey.value]);
</script>

<template>
    <div
        class="app-case-card-badge d-flex flex-column text-secondary text-center align-center justify-center mt-n3"
        data-testid="case-card-badge"
    >
        <v-icon :icon="icon" size="medium" style="height: 40px; width: 30px" />
        <div class="status-text text-caption text-secondary-text" style="max-width: 62px">
            {{ status }}
        </div>
    </div>
</template>

<style scoped>
    .app-case-card-badge {
        height: 88px;
        margin-right: 30px;
    }

    .status-text {
        line-height: 1.2;
    }
</style>
